import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import WhatsAppButton from "@/components/WhatsAppButton";

export function PublicHeader() {
  return (
    <header className="border-b border-zinc-200 bg-white/80 backdrop-blur-xl sticky top-0 z-40">
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-home-link">
          <div className="w-9 h-9 bg-zinc-900 text-white flex items-center justify-center rounded-md">
            <ShieldCheck size={18} strokeWidth={2.5} />
          </div>
          <div>
            <p className="font-display font-black tracking-tighter text-lg leading-none">IIBF BCBF</p>
            <p className="tech-label leading-none mt-0.5">Application Portal</p>
          </div>
        </Link>
        <Link to="/admin/login" data-testid="admin-portal-link" className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500 hover:text-zinc-900 transition-colors">
          Admin Portal →
        </Link>
      </div>
    </header>
  );
}

export function PublicFooter() {
  return (
    <footer className="border-t border-zinc-200 mt-16 bg-zinc-50">
      <div className="max-w-6xl mx-auto px-6 py-10 grid md:grid-cols-3 gap-8">
        <div>
          <p className="font-display font-black text-xl tracking-tighter">IIBF BCBF</p>
          <p className="text-sm text-zinc-600 mt-2 leading-relaxed">
            Indian Institute of Banking & Finance — Business Correspondent / Business Facilitator Application Portal.
          </p>
        </div>
        <div>
          <p className="tech-label mb-3">Contact</p>
          <p className="text-sm text-zinc-700">WhatsApp: <span className="font-semibold">+91 7664861586</span></p>
          <p className="text-sm text-zinc-600 mt-1">Support hours: 9 AM – 7 PM IST</p>
        </div>
        <div className="flex flex-col items-start md:items-end justify-start gap-3">
          <WhatsAppButton variant="inline" />
          <p className="text-xs text-zinc-400 tracking-wide">© {new Date().getFullYear()} IIBF BCBF Portal</p>
        </div>
      </div>
    </footer>
  );
}
